import Storage from '@/lib/Storage'

export const DEFAULT_EARNINGS = {
  grossEarnings: 0,
  netEarnings: 0,
  sales: 0
}

const now = new Date()
const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1)
const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0)

const useEarningsSummaryMonthly = () => {
  const { getListParams } = Storage()

  const fetchFilters = () => {
    const { filter } = getListParams('earnings')
    return {
      startDate: filter ? new Date(filter.start_date_gte) : firstDayOfMonth,
      endDate: filter ? new Date(filter.start_date_lte) : lastDayOfMonth
    }
  }

  const currentStartDate = fetchFilters().startDate
  const currentEndDate = fetchFilters().endDate

  return {
    currentStartDate,
    currentEndDate
  }
}

export { useEarningsSummaryMonthly }
